import React from "react";
import { iconProps } from "../Helper";

const LibraryIcon = ({className}:iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.73486 21.8133C4.31534 21.8482 3.94816 21.7324 3.63331 21.4659C3.31847 21.1995 3.1436 20.8565 3.1087 20.4369L2.18398 9.32158C2.14908 8.90206 2.26487 8.53488 2.53135 8.22003C2.79783 7.90519 3.14083 7.73032 3.56035 7.69542L14.6757 6.7707C15.0952 6.7358 15.4624 6.85159 15.7773 7.11807C16.0921 7.38455 16.267 7.72755 16.3019 8.14707L17.2266 19.2624C17.2615 19.6819 17.1457 20.0491 16.8792 20.364C16.6127 20.6788 16.2697 20.8537 15.8502 20.8886L4.73486 21.8133ZM4.63123 20.5676L15.7466 19.6429C15.8105 19.6376 15.8669 19.6061 15.9156 19.5484C15.9644 19.4908 15.9862 19.43 15.9809 19.3661L15.0562 8.25071C15.0509 8.18676 15.0193 8.13043 14.9616 8.08171C14.904 8.03285 14.8433 8.01107 14.7793 8.01639L3.66399 8.94111C3.60004 8.94643 3.54371 8.97795 3.49499 9.03566C3.44613 9.09324 3.42435 9.15401 3.42967 9.21795L4.35439 20.3333C4.35971 20.3972 4.39123 20.4536 4.44894 20.5023C4.50652 20.5512 4.56729 20.5729 4.63123 20.5676ZM5.67352 18.5994L14.4571 17.8687L11.4234 14.4547L9.34414 17.683L7.50649 15.6971L5.67352 18.5994Z"
        className={className}
        />
      <path
        d="M16.836 17.6573L17.403 17.8372C17.9936 18.0245 18.6106 17.6353 18.6959 17.0217L20.3624 5.03453C20.4385 4.48751 20.0567 3.98241 19.5096 3.90636L10.3904 2.63859C9.84416 2.56264 9.33952 2.94333 9.26253 3.48947L8.78941 6.84569"
        className="custom-icon-stroke"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default LibraryIcon;
